import axios from "axios";
import { Config } from "../Config";
import { clearLocalStorageExcept, setSecureData, userAccessToken } from "../helpers";

const baseURL = Config.partnerServerUrl;

// ---- SAME-FILE NAV BRIDGE (no hooks here) ----
let _navigate = null;           // set from a Router-aware component
let _isRedirecting = false;     // debounce multiple 401 redirects

export const bindPartnerNavigate = (navigateFn) => {
  _navigate = typeof navigateFn === "function" ? navigateFn : null;
};

const appNavigate = (to, options) => {
  if (_navigate) {
    _navigate(to, options);
  } else {
    console.warn("Partner navigate not bound yet; skip redirect:", to);
  }
};
// ----------------------------------------------

const API = axios.create({ baseURL });

// Request interceptor
API.interceptors.request.use(
  (config) => {
    const token = userAccessToken();
    const allowWithoutToken = config?.meta?.allowWithoutToken === true; // opt-out per request

    // 🚫 If no token and not explicitly allowed, stop immediately (no request sent)
    if (!token && !allowWithoutToken) {
      return Promise.reject(null); // caller can detect "skipped due to no token"
    }

    // Attach token only when present
    if (token) {
      config.headers = config.headers || {};
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response) {
      switch (error.response.status) {
        case 401: {
          if (_isRedirecting) return Promise.reject(error); // debounce
          _isRedirecting = true;

          await clearLocalStorageExcept();

          const excludedPaths = ["/", "/no-practices-found"];
          const currentPath = window.location.pathname + window.location.search;

          if (!excludedPaths.includes(window.location.pathname)) {
            await setSecureData("redirect", currentPath);
          }

          if (!window.location.pathname.includes("/login")) {
            appNavigate("/login", { replace: true }); // ← SPA redirect, no reload
          }

          // Release the debounce after a short tick
          setTimeout(() => { _isRedirecting = false; }, 300);
          break;
        }
        case 404:
          // optional 404 handling
          break;
        default:
          // other statuses
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default API;
